<template>
  <div class="extragas-landing">
    <!-- ============================================ -->
    <!-- NAVBAR -->
    <!-- ============================================ -->
    <nav :class="['eg-navbar', { 'eg-navbar-scrolled': scrolled }]">
      <div class="eg-navbar-inner-full">
        <router-link to="/Extragas-web" class="eg-logo-edge">
          <img src="@/assets/logo/extragas-logo.png" alt="EXTRA GAS" class="eg-logo-edge-img" />
        </router-link>

        <div class="eg-nav-center">
          <div class="eg-nav-links">
            <a href="javascript:void(0)" @click="scrollASeccion('inicio')" class="eg-nav-link">Inicio</a>
            <a href="javascript:void(0)" @click="scrollASeccion('tipos')" class="eg-nav-link">Tipos de Recarga</a>
            <a href="javascript:void(0)" @click="abrirConsultaPedido" class="eg-nav-link">Consultar Pedido</a>
            <a href="javascript:void(0)" @click="scrollASeccion('contacto')" class="eg-nav-link">Contacto</a>
          </div>
        </div>

        <div class="eg-nav-actions">
          <button type="button" @click="abrirChatbot" class="eg-btn eg-btn-primary">
            <Icon icon="mdi:fire" class="text-base" />
            <span class="eg-btn-label-desktop">Pedir Servicio</span>
          </button>
          <router-link to="/login" class="eg-btn eg-btn-outline">
            <Icon icon="mdi:login" class="text-base" />
            <span class="eg-btn-label-desktop">Iniciar Sesión</span>
          </router-link>

          <button @click="menuOpen = !menuOpen" class="eg-menu-toggle" aria-label="Abrir menú">
            <Icon :icon="menuOpen ? 'mdi:close' : 'mdi:menu'" class="text-2xl" />
          </button>
        </div>
      </div>

      <transition name="eg-slide">
        <div v-if="menuOpen" class="eg-mobile-menu">
          <a href="javascript:void(0)" @click="scrollASeccion('inicio')" class="eg-mobile-link">
            <Icon icon="mdi:home-outline" class="text-lg" /> Inicio
          </a>
          <a href="javascript:void(0)" @click="scrollASeccion('tipos')" class="eg-mobile-link">
            <Icon icon="mdi:propane-tank" class="text-lg" /> Tipos de Recarga
          </a>
          <a href="javascript:void(0)" @click="menuOpen = false; abrirConsultaPedido()" class="eg-mobile-link">
            <Icon icon="mdi:clipboard-search" class="text-lg" /> Consultar Pedido
          </a>
          <a href="javascript:void(0)" @click="scrollASeccion('contacto')" class="eg-mobile-link">
            <Icon icon="mdi:phone" class="text-lg" /> Contacto
          </a>
          <button type="button" @click="menuOpen = false; abrirChatbot()" class="eg-mobile-link-cta">
            <Icon icon="mdi:fire" class="text-lg" />
            Pedir Servicio
          </button>
          <router-link to="/login" @click="menuOpen = false" class="eg-mobile-link-secondary">
            <Icon icon="mdi:login" class="text-lg" />
            Iniciar Sesión
          </router-link>
        </div>
      </transition>
    </nav>

    <!-- ============================================ -->
    <!-- HERO -->
    <!-- ============================================ -->
    <section id="inicio" class="eg-hero">
      <div class="eg-hero-bg"></div>

      <div class="eg-container eg-hero-content">
        <div class="eg-hero-text">
          <div class="eg-hero-badge">
            <Icon icon="mdi:fire" class="text-lg" />
            <span>Recarga de Gas a Domicilio</span>
          </div>

          <h1 class="eg-hero-title">
            Gas para tu hogar,<br>
            <span class="eg-text-gradient">cuando lo necesites.</span>
          </h1>

          <p class="eg-hero-desc">
            Servicio de recarga de gas profesional, rápido y seguro.
            Pide desde tu celular y nosotros lo llevamos hasta tu puerta.
          </p>

          <div class="eg-hero-buttons">
            <button type="button" @click="abrirChatbot" class="eg-btn eg-btn-hero-primary">
              <Icon icon="mdi:fire" class="text-xl" />
              Pedir Servicio Ahora
            </button>
            <button type="button" @click="abrirConsultaPedido" class="eg-btn eg-btn-hero-secondary">
              <Icon icon="mdi:clipboard-search" class="text-xl" />
              Consultar Pedido
            </button>
          </div>

          <div class="eg-hero-stats">
            <div class="eg-stat">
              <div class="eg-stat-value">24/7</div>
              <div class="eg-stat-label">Atención</div>
            </div>
            <div class="eg-stat-divider"></div>
            <div class="eg-stat">
              <div class="eg-stat-value">30min</div>
              <div class="eg-stat-label">Entrega promedio</div>
            </div>
            <div class="eg-stat-divider"></div>
            <div class="eg-stat">
              <div class="eg-stat-value">100%</div>
              <div class="eg-stat-label">Garantizado</div>
            </div>
          </div>
        </div>

        <div class="eg-hero-image">
          <div class="eg-hero-logo-glow"></div>
          <img src="@/assets/logo/extragas-logo.png" alt="EXTRA GAS" class="eg-hero-logo" />
          <div class="eg-hero-floating eg-float-1">
            <Icon icon="mdi:truck-fast" class="text-2xl" />
          </div>
          <div class="eg-hero-floating eg-float-2">
            <Icon icon="mdi:shield-check" class="text-2xl" />
          </div>
          <div class="eg-hero-floating eg-float-3">
            <Icon icon="mdi:star" class="text-2xl" />
          </div>
        </div>
      </div>

      <div class="eg-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path fill="#ffffff" d="M0,64 C240,120 480,20 720,50 C960,80 1200,110 1440,70 L1440,120 L0,120 Z"></path>
        </svg>
      </div>
    </section>

    <!-- ============================================ -->
    <!-- TIPOS DE RECARGA -->
    <!-- ============================================ -->
    <section id="tipos" class="eg-section eg-section-dark">
      <div class="eg-container">
        <div class="eg-section-header eg-section-header-light">
          <div class="eg-section-badge eg-badge-light">
            <Icon icon="mdi:propane-tank" class="text-sm" />
            <span>Catálogo de Recargas</span>
          </div>
          <h2 class="eg-section-title eg-text-white">
            Elige tu tipo de <span class="eg-text-gradient-light">recarga</span>
          </h2>
          <p class="eg-section-desc eg-text-light">
            Precios en bolívares actualizados. Entrega a domicilio incluida.
          </p>
        </div>

        <div v-if="loadingTipos" class="eg-tipos-loading">
          <Icon icon="mdi:loading" class="animate-spin text-4xl text-white" />
          <p class="eg-text-light mt-3">Cargando catálogo...</p>
        </div>

        <div v-else-if="errorTipos" class="eg-tipos-error">
          <Icon icon="mdi:alert-circle" class="text-4xl" />
          <p class="eg-text-light mt-3">{{ errorTipos }}</p>
          <button @click="cargarTipos" class="eg-btn eg-btn-hero-primary mt-4">
            <Icon icon="mdi:refresh" /> Reintentar
          </button>
        </div>

        <div v-else-if="tiposRecarga.length === 0" class="eg-tipos-error">
          <Icon icon="mdi:fire-off" class="text-4xl" />
          <p class="eg-text-light mt-3">No hay tipos de recarga disponibles</p>
        </div>

        <div v-else class="eg-tipos-grid">
          <div v-for="t in tiposRecarga" :key="t.idTipoRecarga" class="eg-tipo-card">
            <div class="eg-tipo-badge">{{ t.codigo }}</div>

            <div class="eg-tipo-icon">
              <Icon icon="mdi:fire" class="text-3xl" />
            </div>

            <div class="eg-tipo-kg">
              {{ formatearNumero(t.kilogramos, 0) }}<span>kg</span>
            </div>

            <div class="eg-tipo-litros">
              <Icon icon="mdi:water" class="text-xs" />
              ≈ {{ formatearNumero(t.litrosEquivalente, 1) }} L
            </div>

            <h3 class="eg-tipo-nombre">{{ t.nombre }}</h3>

            <p v-if="t.descripcion" class="eg-tipo-desc">{{ t.descripcion }}</p>

            <div class="eg-tipo-precios">
              <div class="eg-tipo-precio-bs">
                <span class="eg-tipo-precio-label">Precio</span>
                <span class="eg-tipo-precio-value">
                  Bs. {{ formatearNumero(t.precioBs, 2) }}
                </span>
              </div>
            </div>

            <button
              type="button"
              @click="abrirChatbotConTipo(t)"
              class="eg-tipo-btn"
            >
              <Icon icon="mdi:cart-plus" class="text-base" />
              Pedir esta recarga
            </button>
          </div>
        </div>

        <div class="eg-cta-center">
          <button type="button" @click="abrirChatbot" class="eg-btn eg-btn-hero-primary">
            <Icon icon="mdi:fire" class="text-xl" />
            Solicitar Recarga Ahora
          </button>
        </div>
      </div>
    </section>

    <!-- ============================================ -->
    <!-- CONSULTA TU PEDIDO — AHORA ES UN MODAL -->
    <!-- ============================================ -->
    <div id="consultar"></div>

    <!-- ============================================ -->
    <!-- CÓMO FUNCIONA -->
    <!-- ============================================ -->
    <section class="eg-section eg-section-gray">
      <div class="eg-container">
        <div class="eg-section-header">
          <div class="eg-section-badge">
            <Icon icon="mdi:lightbulb" class="text-sm" />
            <span>Cómo Funciona</span>
          </div>
          <h2 class="eg-section-title">
            Pide tu gas en <span class="eg-text-gradient">3 simples pasos</span>
          </h2>
        </div>

        <div class="eg-steps">
          <div class="eg-step">
            <div class="eg-step-num">1</div>
            <div class="eg-step-icon">
              <Icon icon="mdi:account-plus" class="text-3xl" />
            </div>
            <h3 class="eg-step-title">Regístrate</h3>
            <p class="eg-step-desc">Crea tu cuenta con tus datos y ubicación</p>
          </div>
          <div class="eg-step-line"></div>
          <div class="eg-step">
            <div class="eg-step-num">2</div>
            <div class="eg-step-icon">
              <Icon icon="mdi:cart" class="text-3xl" />
            </div>
            <h3 class="eg-step-title">Pide tu servicio</h3>
            <p class="eg-step-desc">Elige el tamaño y confirma tu pedido</p>
          </div>
          <div class="eg-step-line"></div>
          <div class="eg-step">
            <div class="eg-step-num">3</div>
            <div class="eg-step-icon">
              <Icon icon="mdi:truck-fast" class="text-3xl" />
            </div>
            <h3 class="eg-step-title">Recíbela en casa</h3>
            <p class="eg-step-desc">Nuestro delivery llega a tu puerta</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ============================================ -->
    <!-- POR QUÉ ELEGIRNOS -->
    <!-- ============================================ -->
    <section class="eg-section">
      <div class="eg-container">
        <div class="eg-section-header">
          <div class="eg-section-badge">
            <Icon icon="mdi:star" class="text-sm" />
            <span>¿Por qué elegirnos?</span>
          </div>
          <h2 class="eg-section-title">
            Somos tu mejor opción <span class="eg-text-gradient">en gas</span>
          </h2>
        </div>

        <div class="eg-benefits-grid">
          <div v-for="(b, i) in beneficios" :key="i" class="eg-benefit">
            <div class="eg-benefit-icon">
              <Icon :icon="b.icon" class="text-2xl" />
            </div>
            <div>
              <h3 class="eg-benefit-title">{{ b.titulo }}</h3>
              <p class="eg-benefit-desc">{{ b.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============================================ -->
    <!-- CONTACTO -->
    <!-- ============================================ -->
    <section id="contacto" class="eg-section eg-section-dark">
      <div class="eg-container">
        <div class="eg-contact-grid">
          <div class="eg-contact-info">
            <div class="eg-section-badge eg-badge-light">
              <Icon icon="mdi:phone" class="text-sm" />
              <span>Contáctanos</span>
            </div>
            <h2 class="eg-section-title eg-text-white">
              ¿Listo para hacer<br>
              <span class="eg-text-gradient-light">tu primer pedido?</span>
            </h2>
            <p class="eg-section-desc eg-text-light">
              Contáctanos por cualquiera de nuestros canales o solicita tu servicio directamente.
            </p>

            <div class="eg-contact-items">
              <div class="eg-contact-item">
                <Icon icon="mdi:whatsapp" class="text-2xl" />
                <div>
                  <div class="eg-contact-label">WhatsApp</div>
                  <div class="eg-contact-value">{{ empresa.telefono || '—' }}</div>
                </div>
              </div>
              <div class="eg-contact-item">
                <Icon icon="mdi:email" class="text-2xl" />
                <div>
                  <div class="eg-contact-label">Email</div>
                  <div class="eg-contact-value">{{ empresa.email || '—' }}</div>
                </div>
              </div>
              <div class="eg-contact-item">
                <Icon icon="mdi:map-marker" class="text-2xl" />
                <div>
                  <div class="eg-contact-label">Ubicación</div>
                  <div class="eg-contact-value">{{ empresa.direccion || '—' }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="eg-contact-cta-card">
            <Icon icon="mdi:fire" class="text-6xl eg-contact-cta-icon" />
            <h3 class="eg-contact-cta-title">Pide tu servicio</h3>
            <p class="eg-contact-cta-desc">
              Regístrate en menos de 2 minutos y solicita tu primera recarga.
            </p>
            <button type="button" @click="abrirChatbot" class="eg-btn eg-btn-full">
              <Icon icon="mdi:fire" class="text-xl" />
              Pedir Servicio
            </button>
            <button type="button" @click="abrirConsultaPedido" class="eg-btn eg-btn-full eg-btn-secondary-full">
              <Icon icon="mdi:clipboard-search" class="text-xl" />
              Consultar Pedido
            </button>
            <router-link to="/login" class="eg-btn eg-btn-full eg-btn-secondary-full">
              <Icon icon="mdi:login" class="text-xl" />
              Iniciar Sesión
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- ============================================ -->
    <!-- FOOTER -->
    <!-- ============================================ -->
    <footer class="eg-footer">
      <div class="eg-container">
        <div class="eg-footer-grid">
          <div>
            <img src="@/assets/logo/extragas-logo.png" alt="EXTRA GAS" class="eg-footer-logo" />
            <p class="eg-footer-desc">
              Servicio profesional de recarga de gas a domicilio.
              Rápido, seguro y confiable.
            </p>
          </div>
          <div>
            <h4 class="eg-footer-title">Navegación</h4>
            <a href="javascript:void(0)" @click="scrollASeccion('inicio')" class="eg-footer-link">Inicio</a>
            <a href="javascript:void(0)" @click="scrollASeccion('tipos')" class="eg-footer-link">Tipos de Recarga</a>
            <button type="button" @click="abrirConsultaPedido" class="eg-footer-link">Consultar Pedido</button>
            <a href="javascript:void(0)" @click="scrollASeccion('contacto')" class="eg-footer-link">Contacto</a>
          </div>
          <div>
            <h4 class="eg-footer-title">Acciones</h4>
            <button type="button" @click="abrirChatbot" class="eg-footer-link">Pedir Servicio</button>
            <router-link to="/login" class="eg-footer-link">Iniciar Sesión</router-link>
          </div>
          <div>
            <h4 class="eg-footer-title">Contacto</h4>
            <p class="eg-footer-text">
              <Icon icon="mdi:phone" class="inline mr-1" /> {{ empresa.telefono || '—' }}
            </p>
            <p class="eg-footer-text">
              <Icon icon="mdi:email" class="inline mr-1" /> {{ empresa.email || '—' }}
            </p>
            <p class="eg-footer-text">
              <Icon icon="mdi:map-marker" class="inline mr-1" /> {{ empresa.ciudad || '—' }}
            </p>
          </div>
        </div>
        <div class="eg-footer-bottom">
          <p>© {{ new Date().getFullYear() }} {{ empresa.nombre || 'EXTRA GAS' }} — Todos los derechos reservados</p>
          <p class="eg-footer-rif">{{ empresa.rif || '' }}</p>
        </div>
      </div>
    </footer>

    <!-- ⭐ MODAL DEL CHATBOT (usa v-model) -->
    <ChatbotModal v-model="chatbotAbierto" />

    <!-- ⭐ MODAL DE CONSULTA DE PEDIDO (usa :value + @input explícito) -->
    <ConsultaPedidoModal
      :value="consultaPedidoAbierta"
      @input="consultaPedidoAbierta = $event"
    />
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import { obtenerDatosEmpresa, cargarConfigTenant } from '@/utils/tenantConfig';
import { obtenerTiposRecarga } from '@/api/gas.js';
import ChatbotModal from '@/components/ChatbotModal.vue';
import ConsultaPedidoModal from '@/components/ConsultaPedidoModal.vue';

const TENANT_PUBLICO = 'extragas_ca';

export default {
  name: 'ExtragasHome',
  components: { Icon, ChatbotModal, ConsultaPedidoModal },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      scrolled: false,
      menuOpen: false,
      chatbotAbierto: false,
      consultaPedidoAbierta: false,
      empresa: {
        nombre: 'EXTRA GAS',
        rif: '',
        telefono: '',
        email: '',
        ciudad: '',
        direccion: ''
      },
      tiposRecarga: [],
      loadingTipos: false,
      errorTipos: null,
      beneficios: [
        { icon: 'mdi:truck-fast', titulo: 'Entrega Rápida', desc: 'Llegamos a tu puerta en tiempo récord.' },
        { icon: 'mdi:shield-check', titulo: '100% Seguro', desc: 'Personal verificado y capacitado.' },
        { icon: 'mdi:cash-multiple', titulo: 'Mejores Precios', desc: 'Tarifas en bolívares competitivas.' },
        { icon: 'mdi:account-star', titulo: 'Atención Personalizada', desc: 'Soporte directo por WhatsApp.' }
      ]
    };
  },
  async mounted() {
    window.addEventListener('scroll', this.handleScroll);

    await this.configurarTenantPublico();
    await this.cargarEmpresa();
    await this.cargarTipos();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    abrirChatbot() {
      this.menuOpen = false;
      this.chatbotAbierto = true;
    },

    abrirChatbotConTipo(tipo) {
      this.menuOpen = false;
      if (tipo && tipo.idTipoRecarga) {
        sessionStorage.setItem('chatbot_tipo_preseleccionado', String(tipo.idTipoRecarga));
      }
      this.chatbotAbierto = true;
    },

    // ⭐ MÉTODO CLAVE — con logs para depurar
    abrirConsultaPedido() {
      console.log('🟢 [abrirConsultaPedido] CLICK detectado');
      this.menuOpen = false;
      this.consultaPedidoAbierta = true;
      console.log('🟢 [abrirConsultaPedido] consultaPedidoAbierta =', this.consultaPedidoAbierta);
    },

    async configurarTenantPublico() {
      try {
        console.log('🏢 Configurando tenant público:', TENANT_PUBLICO);
        localStorage.setItem('selectedTenantId', TENANT_PUBLICO);
        localStorage.setItem('tenantId', TENANT_PUBLICO);
        const guardado = localStorage.getItem('selectedTenantId');
        console.log('✅ Tenant guardado en localStorage:', guardado);
        try {
          const config = await cargarConfigTenant(TENANT_PUBLICO);
          if (config) {
            console.log('✅ Config del tenant cargada:', config.nombreComercial || config.nombreEmpresa);
          } else {
            console.warn('⚠️ Backend no devolvió config del tenant (no es bloqueante)');
          }
        } catch (e) {
          console.warn('⚠️ No se pudo cargar config del tenant:', e);
        }
      } catch (error) {
        console.error('❌ Error configurando tenant público:', error);
      }
    },

    handleScroll() {
      this.scrolled = window.scrollY > 20;
    },

    scrollASeccion(id) {
      this.menuOpen = false;
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (!el) {
          console.warn(`⚠️ No se encontró el elemento #${id}`);
          return;
        }
        const offset = window.innerWidth >= 1024 ? 100 : 85;
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    },

    async cargarEmpresa() {
      try {
        const datos = obtenerDatosEmpresa();
        if (datos && (datos.nombre || datos.nombreComercial)) {
          this.empresa = {
            nombre: datos.nombreComercial || datos.nombre || this.empresa.nombre,
            rif: datos.rif || this.empresa.rif,
            telefono: datos.telefono1 || datos.telefono2 || this.empresa.telefono,
            email: datos.email || this.empresa.email,
            ciudad: datos.ciudad || this.empresa.ciudad,
            direccion: datos.direccion || this.empresa.direccion
          };
          console.log('✅ Empresa cargada:', this.empresa.nombre);
        } else {
          console.warn('⚠️ No hay config de empresa en caché, usando valores por defecto');
        }
      } catch (e) {
        console.warn('⚠️ No se pudo cargar la config de la empresa:', e);
      }
    },

    async cargarTipos() {
      this.loadingTipos = true;
      this.errorTipos = null;
      try {
        const tenantActual = localStorage.getItem('selectedTenantId');
        console.log('📦 Cargando tipos de recarga...');
        console.log('   Tenant actual:', tenantActual);

        if (!tenantActual || tenantActual === 'default') {
          console.warn('⚠️ Tenant NO está configurado correctamente. Forzando...');
          localStorage.setItem('selectedTenantId', TENANT_PUBLICO);
          localStorage.setItem('tenantId', TENANT_PUBLICO);
        }

        const res = await obtenerTiposRecarga('activos');

        if (!res || typeof res !== 'object') {
          this.errorTipos = 'No se recibió respuesta del servidor';
          this.tiposRecarga = [];
          return;
        }

        if (res.success === true) {
          this.tiposRecarga = Array.isArray(res.data) ? res.data : [];
          console.log('✅ Tipos cargados:', this.tiposRecarga.length);
        } else {
          this.errorTipos = res.error || 'Error al cargar los tipos';
          this.tiposRecarga = [];
        }
      } catch (error) {
        console.error('💥 Error cargando tipos:', error);
        this.errorTipos = error?.message || 'Error de conexión';
        this.tiposRecarga = [];
      } finally {
        this.loadingTipos = false;
      }
    },

    formatearNumero(valor, decimales = 2) {
      if (valor === null || valor === undefined || valor === '') return '0';
      const num = Number(valor);
      if (isNaN(num)) return '0';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales
      }).format(num);
    }
  }
};
</script>

<style scoped>
/* =====================================================
   PALETA EXTRA GAS
===================================================== */
.extragas-landing {
  font-family: 'Lexend', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1a2a4a;
  overflow-x: hidden;
}

.eg-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* NAVBAR */
.eg-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  min-height: 72px;
  display: flex;
  align-items: center;
}

.eg-navbar-scrolled {
  box-shadow: 0 4px 20px rgba(26, 42, 74, 0.08);
  min-height: 66px;
}

.eg-navbar-inner-full {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0 1.5rem 0 0;
}

.eg-logo-edge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 100%;
  padding: 6px 16px;
  text-decoration: none;
}

.eg-logo-edge-img {
  height: 62px;
  width: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.eg-logo-edge:hover .eg-logo-edge-img { transform: scale(1.05); }

@media (min-width: 1024px) {
  .eg-logo-edge-img { height: 72px; }
  .eg-logo-edge { padding: 8px 20px; }
}

.eg-nav-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.eg-nav-links {
  display: none;
  align-items: center;
  gap: 0.5rem;
}

.eg-nav-link {
  padding: 0.6rem 1rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1a2a4a;
  border-radius: 0.75rem;
  transition: all 0.2s ease;
  text-decoration: none;
  cursor: pointer;
}

.eg-nav-link:hover {
  background: rgba(93, 173, 226, 0.1);
  color: #5DADE2;
}

.eg-nav-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-right: 1rem;
}

.eg-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.8rem;
  font-weight: 800;
  border-radius: 0.75rem;
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
  border: none;
  letter-spacing: 0.02em;
  white-space: nowrap;
  font-family: inherit;
}

.eg-btn-primary {
  background: #E87A30;
  color: white;
  box-shadow: 0 4px 14px rgba(232, 122, 48, 0.3);
}

.eg-btn-primary:hover {
  background: #d66a20;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(232, 122, 48, 0.4);
}

.eg-btn-outline {
  background: transparent;
  color: #1a2a4a;
  border: 2px solid #5DADE2;
}

.eg-btn-outline:hover {
  background: #5DADE2;
  color: white;
  transform: translateY(-2px);
}

.eg-menu-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 0.75rem;
  background: transparent;
  color: #1a2a4a;
  border: none;
  cursor: pointer;
}

.eg-mobile-menu {
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid rgba(26, 42, 74, 0.1);
  background: white;
}

.eg-mobile-link {
  padding: 0.85rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a2a4a;
  text-decoration: none;
  border-radius: 0.75rem;
  cursor: pointer;
}

.eg-mobile-link:hover { background: rgba(93, 173, 226, 0.1); }

.eg-mobile-link-cta {
  background: rgba(232, 122, 48, 0.12);
  color: #E87A30;
  margin-top: 0.5rem;
  border: 0;
  font-family: inherit;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
  padding: 0.85rem 1rem;
  font-size: 0.9rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.eg-mobile-link-cta:hover { background: #E87A30; color: white; }

.eg-mobile-link-secondary {
  padding: 0.85rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a2a4a;
  text-decoration: none;
  border-radius: 0.75rem;
}

.eg-btn-label-desktop { display: none; }
@media (min-width: 640px) { .eg-btn-label-desktop { display: inline; } }

@media (max-width: 1023px) {
  .eg-nav-actions .eg-btn {
    display: inline-flex !important;
    padding: 0.6rem !important;
    width: 42px !important;
    height: 42px !important;
    justify-content: center !important;
    border-radius: 0.7rem !important;
  }
  .eg-nav-actions .eg-btn .eg-btn-label-desktop { display: none; }
}

@media (max-width: 639px) {
  .eg-navbar { min-height: 60px; }
  .eg-navbar-inner-full { padding: 0 0.5rem 0 0; gap: 0.25rem; }
  .eg-logo-edge { padding: 4px 10px; }
  .eg-logo-edge-img { height: 46px; max-width: 100px; }
  .eg-nav-actions { gap: 0.35rem; padding-right: 0.35rem; }
  .eg-nav-actions .eg-btn { width: 38px !important; height: 38px !important; padding: 0.5rem !important; }
  .eg-menu-toggle { width: 38px; height: 38px; }

  .eg-mobile-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 99;
    margin-top: 0;
    padding: 0.75rem 1rem 1rem;
    border-radius: 0 0 1rem 1rem;
    box-shadow: 0 12px 32px rgba(26, 42, 74, 0.15);
    max-height: calc(100vh - 60px);
    overflow-y: auto;
  }
  .eg-mobile-link,
  .eg-mobile-link-cta,
  .eg-mobile-link-secondary {
    padding: 0.85rem 1rem;
    font-size: 0.92rem;
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }
  .eg-mobile-link-cta { border-radius: 0.75rem; margin-top: 0.35rem; }
  .eg-mobile-link-secondary { border-radius: 0.75rem; }
}

@media (min-width: 640px) and (max-width: 1023px) {
  .eg-navbar { min-height: 68px; }
  .eg-navbar-inner-full { padding: 0 1rem 0 0; }
  .eg-logo-edge { padding: 6px 14px; }
  .eg-logo-edge-img { height: 54px; }

  .eg-mobile-menu {
    position: fixed;
    top: 68px;
    left: 0;
    right: 0;
    z-index: 99;
    margin-top: 0;
    padding: 1rem 1.5rem 1.25rem;
    border-radius: 0 0 1rem 1rem;
    box-shadow: 0 12px 32px rgba(26, 42, 74, 0.15);
    max-height: calc(100vh - 68px);
    overflow-y: auto;
  }
  .eg-mobile-link,
  .eg-mobile-link-cta,
  .eg-mobile-link-secondary {
    padding: 0.95rem 1.1rem;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }
  .eg-mobile-link-cta { border-radius: 0.75rem; }
}

@media (min-width: 1024px) {
  .eg-nav-links { display: flex; }
  .eg-menu-toggle { display: none; }
  .eg-mobile-menu { display: none; }
}

/* HERO */
.eg-hero {
  position: relative;
  padding: 9rem 0 6rem;
  background: linear-gradient(135deg, #f0f6ff 0%, #e8f3fc 50%, #fff5eb 100%);
  overflow: hidden;
}

.eg-hero-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 30%, rgba(93, 173, 226, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(232, 122, 48, 0.12) 0%, transparent 50%);
  pointer-events: none;
}

.eg-hero-content {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

.eg-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(232, 122, 48, 0.12);
  color: #E87A30;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
}

.eg-hero-title {
  font-size: 2.5rem;
  font-weight: 900;
  line-height: 1.1;
  color: #1a2a4a;
  margin-bottom: 1.25rem;
  letter-spacing: -0.02em;
}

.eg-text-gradient {
  background: linear-gradient(135deg, #E87A30 0%, #5DADE2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.eg-text-gradient-light {
  background: linear-gradient(135deg, #FF9F5A 0%, #85C1E9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.eg-hero-desc {
  font-size: 1.05rem;
  line-height: 1.6;
  color: #5a6b8c;
  margin-bottom: 2rem;
  max-width: 540px;
}

.eg-hero-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 2.5rem;
}

.eg-btn-hero-primary {
  background: #E87A30;
  color: white;
  padding: 1rem 1.75rem;
  font-size: 0.9rem;
  box-shadow: 0 8px 24px rgba(232, 122, 48, 0.35);
  font-family: inherit;
}

.eg-btn-hero-primary:hover {
  background: #d66a20;
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(232, 122, 48, 0.45);
}

.eg-btn-hero-secondary {
  background: white;
  color: #1a2a4a;
  padding: 1rem 1.75rem;
  font-size: 0.9rem;
  border: 2px solid #1a2a4a;
}

.eg-btn-hero-secondary:hover {
  background: #1a2a4a;
  color: white;
  transform: translateY(-3px);
}

.eg-hero-stats {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.eg-stat-value {
  font-size: 1.5rem;
  font-weight: 900;
  color: #1a2a4a;
  line-height: 1;
}

.eg-stat-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: #8a9bb5;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.25rem;
}

.eg-stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(26, 42, 74, 0.15);
}

.eg-hero-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.eg-hero-logo-glow {
  position: absolute;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(93, 173, 226, 0.35) 0%, transparent 70%);
  filter: blur(40px);
  animation: eg-pulse 3s ease-in-out infinite;
}

.eg-hero-logo {
  position: relative;
  width: 100%;
  max-width: 380px;
  height: auto;
  border-radius: 1.5rem;
  box-shadow:
    0 25px 50px -12px rgba(26, 42, 74, 0.35),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  animation: eg-float-slow 6s ease-in-out infinite;
  z-index: 2;
}

.eg-hero-floating {
  position: absolute;
  width: 56px;
  height: 56px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 8px 24px rgba(26, 42, 74, 0.25);
  z-index: 3;
}

.eg-float-1 { top: 10%; left: 5%; background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%); animation: eg-float 4s ease-in-out infinite; }
.eg-float-2 { top: 55%; right: 8%; background: linear-gradient(135deg, #5DADE2 0%, #85C1E9 100%); animation: eg-float 5s ease-in-out infinite; animation-delay: 0.5s; }
.eg-float-3 { bottom: 8%; left: 12%; background: linear-gradient(135deg, #1a2a4a 0%, #34495e 100%); animation: eg-float 4.5s ease-in-out infinite; animation-delay: 1s; }

@keyframes eg-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-15px) rotate(5deg); }
}

@keyframes eg-float-slow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

@keyframes eg-pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.eg-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  line-height: 0;
  z-index: 1;
}

.eg-wave svg { width: 100%; height: 80px; display: block; }

@media (min-width: 1024px) {
  .eg-hero { padding: 11rem 0 8rem; }
  .eg-hero-content { grid-template-columns: 1.1fr 1fr; gap: 4rem; }
  .eg-hero-title { font-size: 3.5rem; }
  .eg-hero-desc { font-size: 1.15rem; }
  .eg-hero-logo { max-width: 460px; }
}

/* SECCIONES GENERALES */
.eg-section {
  padding: 5rem 0;
  position: relative;
}

.eg-section-gray { background: #f8fafc; }

.eg-section-dark {
  background: #1a2a4a;
  position: relative;
  overflow: hidden;
}

.eg-section-dark::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 10% 20%, rgba(93, 173, 226, 0.15) 0%, transparent 40%),
    radial-gradient(circle at 90% 80%, rgba(232, 122, 48, 0.12) 0%, transparent 40%);
  pointer-events: none;
}

.eg-section-dark .eg-container { position: relative; z-index: 1; }

.eg-section-header {
  text-align: center;
  max-width: 720px;
  margin: 0 auto 4rem;
}

.eg-section-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(93, 173, 226, 0.12);
  color: #5DADE2;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.eg-badge-light {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.eg-section-title {
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.15;
  color: #1a2a4a;
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.eg-text-white { color: white; }
.eg-section-desc { font-size: 1rem; color: #5a6b8c; line-height: 1.6; }
.eg-text-light { color: rgba(255, 255, 255, 0.75); }

@media (min-width: 768px) {
  .eg-section-title { font-size: 2.5rem; }
  .eg-section-desc { font-size: 1.05rem; }
}

/* TIPOS DE RECARGA */
.eg-tipos-loading,
.eg-tipos-error { text-align: center; padding: 4rem 1rem; color: white; }

.eg-tipos-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  margin-bottom: 3rem;
}

.eg-tipo-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 1.5rem;
  padding: 2rem 1.5rem 1.5rem;
  text-align: center;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.eg-tipo-card:hover {
  background: rgba(255, 255, 255, 0.09);
  border-color: rgba(232, 122, 48, 0.5);
  transform: translateY(-8px);
  box-shadow: 0 20px 40px -12px rgba(232, 122, 48, 0.3);
}

.eg-tipo-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  color: white;
  font-size: 0.7rem;
  font-weight: 900;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  box-shadow: 0 4px 12px rgba(232, 122, 48, 0.4);
}

.eg-tipo-icon {
  width: 56px;
  height: 56px;
  border-radius: 1rem;
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin: 0 auto 1rem;
  box-shadow: 0 8px 20px rgba(232, 122, 48, 0.4);
}

.eg-tipo-kg {
  font-size: 3rem;
  font-weight: 900;
  color: white;
  line-height: 1;
  letter-spacing: -0.03em;
}

.eg-tipo-kg span {
  font-size: 1.2rem;
  margin-left: 0.25rem;
  opacity: 0.7;
  font-weight: 700;
}

.eg-tipo-litros {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  color: #85C1E9;
  font-weight: 800;
  margin-top: 0.5rem;
  letter-spacing: 0.05em;
  background: rgba(93, 173, 226, 0.12);
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  align-self: center;
}

.eg-tipo-nombre {
  font-size: 1rem;
  font-weight: 800;
  color: white;
  margin-top: 1rem;
  margin-bottom: 0.35rem;
}

.eg-tipo-desc {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
  margin-bottom: 1rem;
  min-height: 2.4rem;
}

.eg-tipo-precios {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 0;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.eg-tipo-precio-bs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.eg-tipo-precio-label {
  font-size: 0.65rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.eg-tipo-precio-value {
  font-size: 1.35rem;
  font-weight: 900;
  color: #FF9F5A;
}

.eg-tipo-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.85rem 1rem;
  margin-top: 1rem;
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  color: white;
  border-radius: 0.85rem;
  font-size: 0.8rem;
  font-weight: 900;
  letter-spacing: 0.03em;
  text-decoration: none;
  transition: all 0.25s ease;
  box-shadow: 0 8px 20px rgba(232, 122, 48, 0.35);
  border: 0;
  cursor: pointer;
  font-family: inherit;
}

.eg-tipo-btn:hover {
  background: linear-gradient(135deg, #d66a20 0%, #E87A30 100%);
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(232, 122, 48, 0.5);
}

@media (min-width: 640px) {
  .eg-tipos-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (min-width: 1024px) {
  .eg-tipos-grid { grid-template-columns: repeat(4, 1fr); gap: 1.5rem; }
}

.eg-cta-center { text-align: center; }

/* PASOS */
.eg-steps {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  max-width: 900px;
  margin: 0 auto;
}

.eg-step {
  text-align: center;
  flex: 1;
  position: relative;
}

.eg-step-num {
  position: absolute;
  top: -8px;
  right: 50%;
  transform: translateX(calc(50% + 30px));
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #E87A30;
  color: white;
  font-weight: 900;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(232, 122, 48, 0.4);
}

.eg-step-icon {
  width: 80px;
  height: 80px;
  border-radius: 1.25rem;
  background: linear-gradient(135deg, #5DADE2 0%, #85C1E9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin: 0 auto 1.25rem;
  box-shadow: 0 12px 28px rgba(93, 173, 226, 0.35);
}

.eg-step-title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #1a2a4a;
  margin-bottom: 0.5rem;
}

.eg-step-desc {
  font-size: 0.85rem;
  color: #5a6b8c;
  line-height: 1.5;
}

.eg-step-line {
  display: none;
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #5DADE2 0%, #E87A30 100%);
  border-radius: 999px;
}

@media (min-width: 768px) {
  .eg-steps { flex-direction: row; }
  .eg-step-line { display: block; }
}

/* BENEFICIOS */
.eg-benefits-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  max-width: 1000px;
  margin: 0 auto;
}

.eg-benefit {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-radius: 1.25rem;
  border: 1px solid rgba(26, 42, 74, 0.08);
  transition: all 0.3s ease;
}

.eg-benefit:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 32px -12px rgba(26, 42, 74, 0.15);
}

.eg-benefit-icon {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  border-radius: 1rem;
  background: linear-gradient(135deg, #1a2a4a 0%, #34495e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.eg-benefit-title {
  font-size: 1rem;
  font-weight: 800;
  color: #1a2a4a;
  margin-bottom: 0.25rem;
}

.eg-benefit-desc {
  font-size: 0.85rem;
  color: #5a6b8c;
  line-height: 1.5;
}

@media (min-width: 640px) {
  .eg-benefits-grid { grid-template-columns: repeat(2, 1fr); }
}

/* CONTACTO */
.eg-contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

.eg-contact-items {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.eg-contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  color: white;
}

.eg-contact-label {
  font-size: 0.7rem;
  font-weight: 800;
  color: #85C1E9;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.eg-contact-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: white;
}

.eg-contact-cta-card {
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  border-radius: 1.5rem;
  padding: 2.5rem 2rem;
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(232, 122, 48, 0.5);
}

.eg-contact-cta-icon {
  color: white;
  margin: 0 auto 1rem;
  display: block;
  opacity: 0.9;
}

.eg-contact-cta-title {
  font-size: 1.5rem;
  font-weight: 900;
  color: white;
  margin-bottom: 0.5rem;
}

.eg-contact-cta-desc {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.eg-btn-full {
  width: 100%;
  justify-content: center;
  margin-bottom: 0.75rem;
  background: white;
  color: #E87A30;
  font-family: inherit;
}

.eg-btn-full:hover {
  background: #1a2a4a;
  color: white;
}

.eg-btn-secondary-full {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.eg-btn-secondary-full:hover {
  background: white;
  color: #E87A30;
}

@media (min-width: 1024px) {
  .eg-contact-grid { grid-template-columns: 1.2fr 1fr; }
  .eg-contact-cta-card { padding: 3rem 2.5rem; }
}

/* FOOTER */
.eg-footer {
  background: #0f1a2f;
  padding: 4rem 0 2rem;
  color: rgba(255, 255, 255, 0.7);
}

.eg-footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  margin-bottom: 3rem;
}

.eg-footer-logo {
  height: 60px;
  width: auto;
  object-fit: contain;
  margin-bottom: 1rem;
}

.eg-footer-desc {
  font-size: 0.85rem;
  line-height: 1.6;
  max-width: 300px;
}

.eg-footer-title {
  font-size: 0.75rem;
  font-weight: 900;
  color: #5DADE2;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 1rem;
}

.eg-footer-link {
  display: block;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  padding: 0.3rem 0;
  transition: color 0.2s ease;
  cursor: pointer;
  background: none;
  border: none;
  font-family: inherit;
  text-align: left;
  width: 100%;
}

.eg-footer-link:hover { color: #E87A30; }

.eg-footer-text {
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
}

.eg-footer-bottom {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.75rem;
  text-align: center;
}

.eg-footer-rif { color: #5DADE2; font-weight: 700; }

@media (min-width: 640px) {
  .eg-footer-grid { grid-template-columns: 1.5fr 1fr 1fr 1fr; }
}

@media (min-width: 768px) {
  .eg-footer-bottom {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
}

/* TRANSICIONES */
.eg-slide-enter-active,
.eg-slide-leave-active { transition: all 0.3s ease; }
.eg-slide-enter-from,
.eg-slide-leave-to { opacity: 0; transform: translateY(-10px); }

html { scroll-behavior: smooth; }

#inicio,
#tipos,
#consultar,
#contacto {
  scroll-margin-top: 90px;
}

@media (min-width: 1024px) {
  #inicio,
  #tipos,
  #consultar,
  #contacto {
    scroll-margin-top: 100px;
  }
}

/* =====================================================
   EXTRA: Ajustes solo para móvil
===================================================== */
@media (max-width: 639px) {
  .eg-hero-buttons {
    flex-direction: column;
    gap: 0.6rem;
  }

  .eg-hero-buttons .eg-btn-hero-primary,
  .eg-hero-buttons .eg-btn-hero-secondary {
    width: 100%;
    justify-content: center;
  }

  .eg-hero-stats {
    gap: 1rem;
    justify-content: space-between;
  }

  .eg-stat-value { font-size: 1.2rem; }
  .eg-stat-divider { height: 32px; }

  .eg-cta-center .eg-btn {
    width: 100%;
    justify-content: center;
  }

  .eg-step-num {
    transform: translateX(calc(50% + 24px));
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  .eg-section {
    padding: 3rem 0;
  }

  .eg-section-header {
    margin-bottom: 2.5rem;
  }

  .eg-section-title {
    font-size: 1.6rem;
  }

  .eg-section-desc {
    font-size: 0.9rem;
  }

  .eg-benefit {
    padding: 1.15rem;
    gap: 0.85rem;
  }

  .eg-benefit-icon {
    width: 44px;
    height: 44px;
  }

  .eg-contact-cta-card {
    padding: 2rem 1.5rem;
  }

  .eg-footer {
    padding: 3rem 0 1.5rem;
  }

  .eg-footer-bottom {
    text-align: center;
  }
}
</style>